// extracted by mini-css-extract-plugin
export default {"RefDataManagement":"styles_RefDataManagement__OfVbW","container":"styles_container__451M4"};